import CrossEnv from 'lib/crossenv-core';
import { useEffect, useState } from 'react';

type crossenv = {
  data:{[k: string]: number | string | boolean}
}

declare global {
  interface Window { $crossenv: crossenv}
}

CrossEnv.install();

const useCrossEnv = () => {
  const [env, setEnv] = useState({});

  useEffect(() => {
    setEnv(window.$crossenv);
  }, [window.$crossenv]);

  return [env];
};

const $crossenv = window.$crossenv;

const isSSO = () => {
  return $crossenv.data.isSSO === true || $crossenv.data.isSSO === 'true';
};

export { useCrossEnv, $crossenv, isSSO };
